/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { SOMETHING_WHEN_WRONG } from 'constant/errorMessages'
import { getWarehouseLocationsAPI, LocationsType } from 'features/Location/services/location'
import {
  getProductInventoriesAPI,
  GetProductInventoriesResponseType,
  putInventoryLocationAPI,
  PutInventoryLocationPayloadType,
  putInventoryLocationStatusAPI,
} from 'features/Product/services/inventory'
import { callErrorMsg } from 'helpers/errorMsg'
import { toastSuccess } from 'utils/toast'

export const SLICE_NAME = 'warehouseSlice'
export const mappingWarehouseLocations = ['WAREHOUSE', 'VIRTUAL', 'OFFICE']

export const fetchGetWarehouseLocations = createAsyncThunk(
  `${SLICE_NAME}/fetchGetWarehouseLocations`,
  async (_, { getState, rejectWithValue }) => {
    try {
      let locations: LocationsType[] = []
      const { auth } = getState() as StoreStateType

      if (auth.userData.isSuperAdmin) {
        const response = await getWarehouseLocationsAPI()
        locations = response.data
      } else {
        locations = auth.userData.user_locations.filter((loc) =>
          mappingWarehouseLocations.includes(loc.location_type.toUpperCase()),
        )
      }

      return locations
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchGetProductWarehouse = createAsyncThunk(
  `${SLICE_NAME}/fetchGetProductWarehouse`,
  async (params: Parameters<typeof getProductInventoriesAPI>[0], { getState, rejectWithValue }) => {
    try {
      const {
        auth,
        warehouse: { query },
      } = getState() as StoreStateType

      const locationIds = params?.['filter.location_ids']?.length
        ? params['filter.location_ids']
        : auth.userData.user_locations
            .filter((loc) => mappingWarehouseLocations.includes(loc.location_type.toUpperCase()))
            .map((loc) => loc.location_id)

      const response = await getProductInventoriesAPI({
        ...query,
        ...params,
        'filter.location_types': mappingWarehouseLocations,
        'filter.location_ids': locationIds,
      })

      const result: GetProductInventoriesResponseType = {
        data: response.data.data,
        pagination: response.data.pagination,
      }

      return result
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchPutInventoryLocation = createAsyncThunk(
  `${SLICE_NAME}/fetchPutInventoryLocation`,
  async (
    data: {
      locationId: number
      productId: number
      payload: PutInventoryLocationPayloadType
    },
    { rejectWithValue, dispatch, getState },
  ) => {
    try {
      const {
        warehouse: { query },
      } = getState() as StoreStateType

      const response = await putInventoryLocationAPI(data.locationId, data.productId, data.payload)

      toastSuccess('Data berhasil diupdate')
      dispatch(
        fetchGetProductWarehouse({
          ...query,
        }),
      )

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)

export const fetchPutInventoryLocationStatus = createAsyncThunk(
  `${SLICE_NAME}/fetchPutInventoryLocationStatus`,
  async (
    data: {
      locationId: number
      productId: number
      isActive: boolean
    },
    { rejectWithValue, dispatch, getState },
  ) => {
    try {
      const {
        warehouse: { query },
      } = getState() as StoreStateType

      const response = await putInventoryLocationStatusAPI(
        data.locationId,
        data.productId,
        data.isActive,
      )

      toastSuccess('Data berhasil diupdate')
      dispatch(
        fetchGetProductWarehouse({
          ...query,
        }),
      )

      return response.data
    } catch (err) {
      callErrorMsg(err)
      return rejectWithValue(SOMETHING_WHEN_WRONG)
    }
  },
)
